import { NgModule } from '@angular/core';

import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[inova-button]',
})
export class InovaButton {
  @HostBinding('class') classes = 'inova-front-core-btn';

  constructor() { }

}

@NgModule({
  declarations: [InovaButton],
  imports: [],
  exports:[InovaButton]
})
export class InovaCoreButtonModule { }
